module.exports = __webpack_public_path__ + "static/media/startimes.f91ab232.svg";